import { ClinicalTaskEditFields } from '@bariendo/lib/clinical-tasks';
import { getOperationOutcomeMessage } from '@bariendo/lib/error';
import { alert } from '@/services/alert';
import { useCreateTask } from '@/hooks/useCreateTask';
import { Patient, Reference, Task } from '@medplum/fhirtypes';
import { ReactElement, useCallback } from 'react';
import { TaskForm } from './TaskForm';

export interface CreateTaskFormProps {
  patient: Reference<Patient>;
  onSave: (task: Task) => void;
  onCancel: () => void;
}

export function CreateTaskForm({ patient, onSave, onCancel }: CreateTaskFormProps): ReactElement {
  const { createTask, loading } = useCreateTask(patient);

  const handleSubmit = useCallback(
    async (fields: ClinicalTaskEditFields) => {
      try {
        const task = await createTask(fields);
        onSave(task);
      } catch (e) {
        alert.error(`Couldn't create task: ${getOperationOutcomeMessage(e)}`);
      }
    },
    [createTask, onSave]
  );

  return <TaskForm loading={loading} submitLabel="Save" onCancel={onCancel} onSubmit={handleSubmit} />;
}
